module.exports = __webpack_public_path__ + "img/zh_flag.665ecfb1.jpg";